import { render, staticRenderFns } from "./filter-item.vue?vue&type=template&id=dff16964&"
import script from "./filter-item.vue?vue&type=script&lang=js&"
export * from "./filter-item.vue?vue&type=script&lang=js&"
import style0 from "./filter-item.vue?vue&type=style&index=0&id=dff16964&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports